define('views/header',['require','config/application','mediator','chaplin','views/base/view','text!templates/header.ejs','views/header-menu'],function(require) {
    'use strict';

    var applicationConfig = require('config/application'),
        mediator = require('mediator'),
        Chaplin = require('chaplin'),
        View = require('views/base/view'),
        template = require('text!templates/header.ejs'),
        HeaderMenuView = require('views/header-menu');

    var HeaderView = View.extend({
        autoRender: true,
        className: 'header',
        region: 'header',
        id: 'header',
        template: template,

        regions: {
            'header-menu': '#header-menu-container'
        },

        listen: {
            'signinStatus mediator': 'render'
        },

        initialize: function () {
            View.prototype.initialize.apply(this, arguments);
            this.model = new Chaplin.Model({});
            return this;
        },

        getTemplateData: function() {
            var object = View.prototype.getTemplateData.apply(this, arguments);

            object.themes = applicationConfig.themes;
            object.locales = applicationConfig.locales;
            object.currentLocale = applicationConfig.locale;

            return object;
        },

        render: function() {
            View.prototype.render.apply(this, arguments);
            this.subview('menu',  new HeaderMenuView({ collection: mediator.mainMenu, container: this.$('.navbar-inner')[0] }));
        }
    });

    return HeaderView;
});

